// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQSectionFooter_root__3sXG_","content":"FAQSectionFooter_content__3_ev7"};